<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="calibre3"><span id="Page_3" title="[Pg 3]"></span></p>
<h2 class="nobreak" id="Third_Day">Third Day.</h2>
</div>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="calibre10">
<img alt="" class="drop-cap1" id="id-3946301196875954378" src="Images/img0005.jpg"/>
</div>
<div class="pcalibre verse">In the cause of friendship ...</div>
<div class="verse7">brave all dangers.</div>
</div>
<span class="calibre11"><i class="calibre8">Pickwick Papers.</i></span>
</div>
</div>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="verse">Let us be among the few who do their duty.</div>
</div>
</div>
</div>
<p class="author"><i class="calibre8">Martin Chuzzlewit.</i></p>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="verse2">Fortune will not bear chiding.</div>
<div class="verse">We must not reproach her, or she shuns us.</div>
</div>
</div>
</div>
<p class="author"><i class="calibre8">Old Curiosity Shop.</i></p>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="verse">It is an undoubted fact that all remarkable</div>
<div class="verse7">men have had</div>
<div class="verse1">remarkable mothers.</div>
</div>
</div>
</div>
<p class="author"><i class="calibre8">Haunted Man.</i></p>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="verse">Every man has his enemies.</div>
</div>
</div>
</div>
<p class="author"><i class="calibre8">Old Curiosity Shop.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?1dd7a851